export default __webpack_public_path__ + "static/media/complete_job.d7d051c4.svg";